import { createSlice } from '@reduxjs/toolkit';

let Slices = [];
let formReducers = {};
let formActions  = {};

/*---------------------------------------------------------------*/

export const contactSlice = createSlice({
    name: 'contactForm',
    initialState: {},
    reducers: {
        updateContactForm: (state, action) => {
            return {...state, ...action.payload}
        },
        resetContactForm: () => {
            return {}
        }
    },
});

Slices.push(contactSlice);

/*---------------------------------------------------------------*/

// Build export objects
for (const Slice of Slices) {
    let reducer  = { [Slice.name]: Slice.reducer };
    formActions  = { ...formActions, ...Slice.actions };
    formReducers = { ...formReducers, ...reducer };
}

export { formActions };
export { formReducers };
